import React from 'react';
import AppButton from '../buttons/AppButton';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/stravnik';
import { jidelnicekResetObbodi } from '../../redux/actions/jidelnicek';

const ProfileItem = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch()

  return (
    <>
    {/* 
    <TouchableHighlight style={[itemStyles.list_item, isDarkMode ? itemStyles.list_item_dark : itemStyles.list_item_light, props.style]} onPress={props.onPress} underlayColor="transparent">
      <View style={mainStyles.horizontalView}>
        <View>
        <Text style={[itemStyles.list_label, itemStyles.list_label_big, isDarkMode ? itemStyles.list_label_dark : itemStyles.list_label_light, props.style_label]}>{props.data.user.jmeno}{props.data.user.prijmeni}</Text>
        <Text style={[itemStyles.list_label, isDarkMode ? itemStyles.list_label_dark : itemStyles.list_label_light, props.style_label]}>{props.data.zarizeni.nazev}</Text>
        <Text style={[itemStyles.list_label, isDarkMode ? itemStyles.list_label_dark : itemStyles.list_label_light, props.style_label]}>{props.data.zarizeni.mesto}</Text>
        </View>
        <View>
        <Text style={[itemStyles.list_label, itemStyles.list_label_big, isDarkMode ? itemStyles.list_label_dark : itemStyles.list_label_light, props.style_label]}>{props.data.user.username}</Text>
        <AppButton sm onPress={() => {
          Alert.alert(t('account.profile.deleteConfirm'), null, [
            {text: t('confirmation.no'), style: "cancel"},
            {text: t('confirmation.yes'), style: "destructive", onPress: () => {
              dispatch(logout(props.idx)).then(() => {
                dispatch(jidelnicekResetObbodi())
              }).catch(() => {})
            }}
          ]);
        }} style={{paddingLeft: 10, paddingRight: 0}}>
              <MaterialCommunityIcons style={{marginRight: 4}} name="trash-can-outline" color={colors.white} size={18} />
            </AppButton>
        </View>
        </View>
    </TouchableHighlight>
    */}
    </>
  );

}

export default ProfileItem